import * as React from 'react';
import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { CheckboxList, ComplexValue } from 'ui';
import { FIELD_TYPE } from 'app/infrastructure/simple-form/field-types';

export interface CheckboxListOptions {
  [x: string]: ComplexValue<number>[];
}

export const createCheckboxListOptions = (fieldProps: SimpleFormComponentProps, options: ComplexValue<number>[]) => {

  if (options) {
    const values: CheckboxListOptions = {
      [FIELD_TYPE.CHECKBOX_LIST]: options,
      [FIELD_TYPE.CHECKBOX]: [
        {
          value: options[0].value
        }
      ]
    };
    return values[fieldProps.type];
  }
  return [];
};

export const checkboxListCreator = (fieldData: SimpleFormComponentProps, fieldMethods: SimpleFormMethods, fieldState?: any) =>
  <CheckboxList
    className={undefined}
    componentId={fieldData.name}
    label={fieldMethods.buildLabel(fieldData.label)}
    valueItems={fieldMethods.getProperty(fieldData.name)}
    options={createCheckboxListOptions(fieldData, fieldData.staticOptions)}
    onChange={fieldMethods.handleChange(fieldData.name)}
  />;
